import React from "react"

import Image from "gatsby-image"
import { useSliderImages } from "./useSliderImages"

const useSliderData = () => {
  const images = useSliderImages()
  return [
    {
      id: "01",
      title: "Sklep",
      subtitle: "",
      image: (
        <Image
          imgStyle={{ objectFit: "cover" }}
          fluid={images._002.childImageSharp.fluid}
        />
      ),
      blur: (
        <Image
          imgStyle={{ objectFit: "cover" }}
          fluid={images._002b.childImageSharp.fluid}
        />
      ),
      href: "https://sklep.beksinski.com.pl/",
    },
    {
      id: "02",
      title: "Bilety",
      subtitle: "",
      image: (
        <Image
          imgStyle={{ objectFit: "cover" }}
          fluid={images._001.childImageSharp.fluid}
        />
      ),
      blur: (
        <Image
          imgStyle={{ objectFit: "cover" }}
          fluid={images._001b.childImageSharp.fluid}
        />
      ),
      href: "https://koncerty-beksinski.pl/",
    },
    {
      id: "03",
      title: "Wystawy",
      subtitle: "",
      image: (
        <Image
          imgStyle={{ objectFit: "cover" }}
          fluid={images._004.childImageSharp.fluid}
        />
      ),
      blur: (
        <Image
          imgStyle={{ objectFit: "cover" }}
          fluid={images._004b.childImageSharp.fluid}
        />
      ),
      slug: "/wystawy",
    },
    {
      id: "04",
      title: "Koncerty",
      subtitle: "",
      image: (
        <Image
          imgStyle={{ objectFit: "cover" }}
          fluid={images._009.childImageSharp.fluid}
        />
      ),
      blur: (
        <Image
          imgStyle={{ objectFit: "cover" }}
          fluid={images._009b.childImageSharp.fluid}
        />
      ),
      slug: "/koncerty",
    },
    {
      id: "05",
      title: "Reality",
      subtitle: "Virtual",
      image: (
        <Image
          imgStyle={{ objectFit: "cover" }}
          fluid={images._003.childImageSharp.fluid}
        />
      ),
      blur: (
        <Image
          imgStyle={{ objectFit: "cover" }}
          fluid={images._003b.childImageSharp.fluid}
        />
      ),
      slug: "/virtual-reality",
    },
    {
      id: "06",
      title: "Spektakle",
      subtitle: "",
      image: (
        <Image
          imgStyle={{ objectFit: "cover" }}
          fluid={images._006.childImageSharp.fluid}
        />
      ),
      blur: (
        <Image
          imgStyle={{ objectFit: "cover" }}
          fluid={images._006b.childImageSharp.fluid}
        />
      ),
      slug: "/spektakle",
    },
    {
      id: "07",
      title: "Dla szkół",
      subtitle: "",
      image: (
        <Image
          imgStyle={{ objectFit: "cover" }}
          fluid={images._007.childImageSharp.fluid}
        />
      ),
      blur: (
        <Image
          imgStyle={{ objectFit: "cover" }}
          fluid={images._007b.childImageSharp.fluid}
        />
      ),
      slug: "/dla-szkol",
    },
    {
      id: "08",
      title: "Biografia",
      subtitle: "Beksiński",
      image: (
        <Image
          imgStyle={{ objectFit: "cover" }}
          fluid={images._008.childImageSharp.fluid}
        />
      ),
      blur: (
        <Image
          imgStyle={{ objectFit: "cover" }}
          fluid={images._008b.childImageSharp.fluid}
        />
      ),
      slug: "/biografia",
    },
    {
      id: "09",
      title: "O fundacji",
      subtitle: "",
      image: (
        <Image
          imgStyle={{ objectFit: "cover" }}
          fluid={images._005.childImageSharp.fluid}
        />
      ),
      blur: (
        <Image
          imgStyle={{ objectFit: "cover" }}
          fluid={images._005b.childImageSharp.fluid}
        />
      ),
      slug: "/o-fundacji",
    },
    {
      id: "10",
      title: "Audiobooki",
      subtitle: "",
      image: (
        <Image
          imgStyle={{ objectFit: "cover" }}
          fluid={images._011.childImageSharp.fluid}
        />
      ),
      blur: (
        <Image
          imgStyle={{ objectFit: "cover" }}
          fluid={images._011b.childImageSharp.fluid}
        />
      ),
      slug: "/audiobooki",
    },
    {
      id: "11",
      title: "Kontakt",
      subtitle: "",
      image: (
        <Image
          imgStyle={{ objectFit: "cover" }}
          fluid={images._010.childImageSharp.fluid}
        />
      ),
      blur: (
        <Image
          imgStyle={{ objectFit: "cover" }}
          fluid={images._010b.childImageSharp.fluid}
        />
      ),
      slug: "/kontakt",
    },
  ]
}

export { useSliderData }
